export enum DocumentTypeEnum {
  Pdf,
  Docx,
}
